<template>
  <router-view class="content"/>
</template>

<style lang="scss">
@import "/src/assets/css/_base.global.scss";

</style>
